module.exports = __webpack_public_path__ + "img/robot-empty.39e80714.png";